import { ACTION_TYPES } from '../actions/carCleaning/carCleaning.actionType';

const INITIAL_STATE = {
  isLoading: true,
  cleaningQaList: [],
  cleaningHistoryList: [],
  cleaningDetail: {},
  trainingTutorials: [],
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTION_TYPES.CLEANING_REQUEST_START:
      return { ...state, isLoading: true };
    case ACTION_TYPES.CLEANING_REQUEST_END:
      return { ...state, isLoading: false };
    case ACTION_TYPES.FETCH_CLEANING_QA_LIST_SUCCESS:
      return { ...state, cleaningQaList: action.payload };
    case ACTION_TYPES.FETCH_CLEANING_HISTORY_LIST_SUCCESS:
      return { ...state, cleaningHistoryList: action.payload };
    case ACTION_TYPES.FETCH_CLEANING_DETAIL_SUCCESS:
      return { ...state, cleaningDetail: action.payload };
    case ACTION_TYPES.FETCH_TRAINING_TUTORIALS_SUCCESS:
      return { ...state, trainingTutorials: action.payload };
    default:
      return state;
  }
};

export default reducer;
